import * as Sentry from '@sentry/browser'

export default {
  methods: {
    getIssueDataFromAtlassianPaginated (issueArray, nextPageToken = null, maxResults = 50) {
      const payload = {
        jql: `id in (${issueArray.join(',')})`,
        fields: ['issuetype', 'summary', 'status'],
        fieldsByKeys: false,
        maxResults: maxResults
      }

      if (nextPageToken) {
        payload.nextPageToken = nextPageToken
      }

      window.AP.request({
        url: '/rest/api/3/search/jql',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        success: response => {
          response = JSON.parse(response)
          let donePaginating = !response.nextPageToken
          this.setIssues(response, donePaginating)
          if (!donePaginating) {
            this.getIssueDataFromAtlassianPaginated(issueArray, response.nextPageToken, maxResults)
          }
        },
        error: (response) => {
          Sentry.captureMessage(response)
        }
      })
    },
    getComponents () {
      window.AP.request({
        url: `/rest/api/3/project/${this.currentProject.id}/components`,
        success: response => {
          // convert the string response to JSON
          response = JSON.parse(response)
          this.components = response
        },
        error: (response) => {
          Sentry.captureMessage(response)
        }
      })
    },
    getStatusesForCurrentProject () {
      window.AP.request({
        url: `/rest/api/3/project/${this.currentProject.id}/statuses`,
        success: response => {
          // convert the string response to JSON
          response = JSON.parse(response)
          this.setStatusOptions(response)
        },
        error: (response) => {
          Sentry.captureMessage(response)
        }
      })
    },
    getAllStatuses () {
      window.AP.request({
        url: '/rest/api/3/status',
        success: response => {
          // convert the string response to JSON
          response = JSON.parse(response)
          this.setStatusOptions(response)
        },
        error: (response) => {
          Sentry.captureMessage(response)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/getDataFromAtlassian.js